export type Theme = "light" | "dark";

const STORAGE_KEY = "bioflow-tma:theme";

/**
 * По умолчанию тема светлая, но пользователь может выбрать свою — тогда
 * выбор побеждает и переживает перезапуск приложения.
 *
 * Храним в localStorage, а не в CloudStorage Telegram: последний асинхронный
 * и появился только в Bot API 6.9, а тут нужно значение синхронно на первом
 * кадре, иначе приложение мигнёт чужой темой.
 */
export function getStoredTheme(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    // В некоторых WebView localStorage недоступен — молча живём без него.
    return null;
  }
}

export function storeTheme(theme: Theme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* см. выше */
  }
}

type ThemeListener = (theme: Theme) => void;

const listeners = new Set<ThemeListener>();

/**
 * Подписка на смену темы: telegram.ts перекрашивает шапку клиента, а этот
 * модуль ничего не знает про рантайм Telegram — иначе цикл импортов.
 */
export function onThemeChange(listener: ThemeListener): void {
  listeners.add(listener);
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  for (const listener of listeners) listener(theme);
}

export function currentTheme(): Theme {
  return document.documentElement.dataset.theme === "dark" ? "dark" : "light";
}

export function toggleTheme(): Theme {
  const next: Theme = currentTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  storeTheme(next);
  return next;
}
